var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditWidgetLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 136,
    viewBox: "0 0 180 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#856DCB",
    fillRule: "nonzero",
    d: "M169.121 73.631c-6.324 8.632-4.237 20.954-.581 30.77 1.224 3.286 2.615 6.762 1.98 10.337-.775 4.371-4.42 7.646-8.207 9.43-6.906 3.25-15.063 2.731-21.24-1.365-5.33-3.535-9.082-9.41-14.516-12.776-9.094-5.632-20.9-3.116-31.022 1.184-7.16 3.042-15.005 6.96-21.983 4.15-4.91-1.976-8.217-7.007-9.956-12.385-.84-2.597-1.428-5.415-3.102-7.448-.995-1.208-2.31-2.05-3.662-2.754-12.339-6.427-28.21-2.41-40.173-9.582C8.582 78.35 3.555 68.95 1.467 59.07-.622 49.19-.105 38.759.727 28.507c.591-7.286 1.526-15.071 5.93-20.796C11.314 1.658 19.119-.748 26.098.2c6.98.947 13.238 4.804 18.712 9.407 6.847 5.743 13.147 12.954 21.663 15.134 5.8 1.485 11.962.434 17.992-.03 10.08-.775 20.124.117 30.106 1.124 9.556.964 19.179 2.041 28.23 5.202 6.404 2.237 11.48 6.464 17.51 9.353 3.93 1.884 8.255 2.32 11.954 4.754 4.564 2.996 8.69 8.306 7.35 14.677-1.264 6.056-7.134 9.228-10.494 13.81z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87.268,
    height: 54.443,
    y: 5.304,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 85.268,
    height: 52.443,
    x: 6.504,
    y: 1,
    stroke: "#D8DBF0",
    strokeWidth: 2,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillRule: "nonzero",
    d: "M62.543 40.425A18.815 18.815 0 0 0 49.239 8.307V27.12l13.304 13.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#856DCB",
    fillRule: "nonzero",
    d: "M49.239 8.307a18.817 18.817 0 0 0-9.001 35.34l9-16.526V8.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0BCCF",
    fillRule: "nonzero",
    d: "M62.543 40.425L49.239 27.121l-9.001 16.526a18.825 18.825 0 0 0 22.305-3.222z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#856DCB",
    fillRule: "nonzero",
    d: "M8.807 43.134h3.603v3.603H8.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillRule: "nonzero",
    d: "M14.011 43.134h3.603v3.603h-3.603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575A89",
    fillRule: "nonzero",
    d: "M19.215 43.134h3.603v3.603h-3.603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillRule: "nonzero",
    d: "M71.056 43.934h14.812v1H71.056zM71.056 45.736h14.812v1H71.056zM71.056 47.537h14.812v1H71.056z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.639,
    height: 54.443,
    x: 27.422,
    y: 81.164,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.639,
    height: 52.443,
    x: 33.425,
    y: 76.96,
    stroke: "#D8DBF0",
    strokeWidth: 2,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#856DCB",
    fillRule: "nonzero",
    d: "M35.027 124.26h2.676v2.676h-2.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillRule: "nonzero",
    d: "M38.893 124.26h2.676v2.676h-2.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575A89",
    fillRule: "nonzero",
    d: "M42.759 124.26h2.676v2.676h-2.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillRule: "nonzero",
    d: "M65.051 125.423h10.408v1H65.051zM65.051 126.689h10.408v1H65.051zM65.051 127.954h10.408v1H65.051zM57.245 85.567v4.404a13.21 13.21 0 0 1 9.341 22.551l3.114 3.114a17.614 17.614 0 0 0-12.455-30.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0BCCF",
    fillRule: "nonzero",
    d: "M69.7 115.636l-3.114-3.114a13.207 13.207 0 0 1-17.334 1.175l-2.665 3.507c7.013 5.33 16.885 4.66 23.113-1.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#856DCB",
    fillRule: "nonzero",
    d: "M44.035 103.18c0-7.295 5.914-13.21 13.21-13.21v-4.403a17.614 17.614 0 0 0-10.658 31.637l2.665-3.507a13.187 13.187 0 0 1-5.217-10.516z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.639,
    height: 54.443,
    x: 101.48,
    y: 47.137,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.639,
    height: 52.443,
    x: 107.484,
    y: 42.933,
    stroke: "#D8DBF0",
    strokeWidth: 2,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3D56",
    strokeWidth: 2,
    d: "M111.287 45.336v41.632h40.232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0BCCF",
    fillRule: "nonzero",
    d: "M113.489 72.357h9.007v14.411h-9.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillRule: "nonzero",
    d: "M126.499 62.549h9.007v24.219h-9.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#856DCB",
    fillRule: "nonzero",
    d: "M139.509 51.14h9.007v35.628h-9.007zM110.687 90.234h2.676v2.676h-2.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillRule: "nonzero",
    d: "M114.553 90.234h2.676v2.676h-2.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575A89",
    fillRule: "nonzero",
    d: "M118.419 90.234h2.676v2.676h-2.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillRule: "nonzero",
    d: "M140.71 91.396h10.408v1H140.71zM140.71 92.662h10.408v1H140.71zM140.71 93.928h10.408v1H140.71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditWidgetLogo);
export default __webpack_public_path__ + "static/media/audit-widget-logo.13a869a8d118029e1ed5a5e3227a4f9f.svg";
export { ForwardRef as ReactComponent };